import { formatDate } from 'src/utils/formatDate';
import type { QTableColumn } from 'quasar';
import { getRoleLabel, Role } from './enum/Role';
import { QuestionCategoryContainQuestionTemplatesAttributes } from './QuestionCategoryModel';
import { AnswerModel, AnswerGetAttributes } from './AnswerModel';
export interface TargetResourceGetAttributes {
  id: string;
  name: string;
  resource_id: string;
  resource_name: string;
  answers: AnswerGetAttributes[]; //回答があるとここに回答がくる
}
export class TargetResourceModel {
  id: string;
  name: string;
  resource_id: string;
  resource_name: string;
  answers: AnswerModel[]; //回答があるとここに回答がくる

  constructor(input?: TargetResourceGetAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.resource_id = input ? input.resource_id : '';
    this.resource_name = input ? input.resource_name : '';
    this.answers = input
      ? input.answers.map((answer) => new AnswerModel(answer, []))
      : [];
  }
}
export type TargetResourceCollection = TargetResourceModel[];
export const TargetResourceTableBaseColumns: QTableColumn[] = [
  {
    name: 'name',
    label: 'リソース名',
    align: 'left',
    field: 'name',
    sortable: true,
  },
];
